import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadProducts, getCsvProductModel } from '../app/store/actions/products';
import UploadFilesComponent from '../components/upload';
import ProductImportErrors from '../components/upload/ProductImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadProducts(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvProductModel();
  }

  goBack = () => {
    history.push(ROUTES.PRODUCTS);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importProducts" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="productImportText1" /></p>
            <p><Translate value="productImportText2" /></p>
            <p><Translate value="productImportText3" /></p>
            <p><Translate value="productImportText4" /></p>
            <p><Translate value="productImportText5" /></p>
            <p><Translate value="productImportText7" /></p>
            <p><Translate value="productImportText6" /></p>           
          </div>


          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<ProductImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadProducts: file => dispatch(uploadProducts(file)),
  getCsvProductModel: () => dispatch(getCsvProductModel()),
});

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadProductsPage);
